// extracted by mini-css-extract-plugin
export default {"grid":"Fjkb8___List-module__grid","flex":"sNITK___List-module__flex"};